<template>
  <div class="geocoder w-100">
    <input type="text" class="vehicle-input calculator-input-square w-100" style="text-align: left;" v-model="address"
      @keyup="(e)=>geocode(e)" placeholder="Adresse" />
    <div class="geocoder-container position-absolute" v-if="listOfAdresses.length > 0">
      <div v-for="(result, index) in listOfAdresses" class="geocoder-items" :key="index"
        @click="calculateDistance(result)">
        <div class="ml-10px">
          {{ result.properties.name }} <span v-if="result.properties.name">,</span>
          {{ result.properties.housenumber }} {{ result.properties.street
          }}<span v-if="result.properties.housenumber || result.properties.street">,</span>
          {{ result.properties.city
          }}<span v-if="result.properties.city">,</span>
          {{ result.properties.county }}
          <span v-if="result.properties.county">,</span>
          {{ result.properties.country }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      address: "",
      result: null,
      listOfAdresses: [],
      position: [45, -73],
    };
  },
  methods: {
    geocode(event) {
      console.log(event)
      if (event.code == "Backspace") {
        this.$emit('removeResult', true)
    }
      if (this.address) {
        let url =
          "https://photon.komoot.io/api/?q=" +
          this.address +
          "&lat=" +
          this.position[0] +
          "&lon=" +
          this.position[1];
        axios
          .get(url)
          .then((listOfAdresses) => {
            this.listOfAdresses = listOfAdresses.data.features;
          })
          .catch();
      } else {
        this.listOfAdresses = [];
      }
    },
    calculateDistance(result) {
      this.address = ""
      if (result.properties.name) {
        this.address = result.properties.name + ' '
      }
      if (result.properties.housenumber) {
        this.address += result.properties.housenumber + ' '
      }
      if (result.properties.street) {
        this.address += result.properties.street + ' '
      }
      if (result.properties.city) {
        this.address += result.properties.city + ' '
      }
      if (result.properties.county) {
        this.address += result.properties.county + ' '
      }
      if (result.properties.country) {
        this.address += result.properties.country + ' '
      }
      this.listOfAdresses = []
      let url = 'https://router.project-osrm.org/route/v1/driving/' + result.geometry.coordinates[0] + ',' + result.geometry.coordinates[1] + ';-72.5360909,46.3467482?overview=false&alternatives=true&steps=true'
      axios
        .get(url)
        .then((direction) => {
          this.result = direction.data.routes[0].distance
          this.$emit('update:modelValue', (this.result / 1000).toFixed(0))
        })
        .catch();
    }
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position =>
        (this.position = [
          position.coords.latitude,
          position.coords.longitude
        ])
      )
    }
  }
};
</script>
<style>
.geocoder {
  position: relative;
}

.geocoder-container {
  padding: 10px;
  max-height: 300px;
  width: calc(100% - 40px);
  overflow-y: auto;
  border: 2px solid var(--text-color);
  background-color: white;
  z-index: 300;
}

.geocoder-items {
  color: var(--color);
  font-family: var(--font);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  padding: 5px;

}

.geocoder-items:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.geocoder-container::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.geocoder-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.geocoder-container::-webkit-scrollbar-thumb {
  background: var(--text-color);
}

/* Handle on hover */
.geocoder-container::-webkit-scrollbar-thumb:hover {
  background: var(--text-color);
}
</style>
